import { createReducer } from '@reduxjs/toolkit';
import { API, SCOPE_CRM_AUDIT } from '../../constants';
import { INITIAL_LIST_STATE_EXTENDED } from '../helpers/common';
import { extendListBuilder, generateListActions } from '../helpers/listActionsHelpers';

export const INITIAL_STATE = {
  ...INITIAL_LIST_STATE_EXTENDED,
  order: ['createdAt', 'desc'],
  pagination: { page: 1, perPage: 20 },
  params: {},
};

const listActions = generateListActions({
  scope: SCOPE_CRM_AUDIT,
  apiMethod: {
    GET_LIST: API.CRM_AUDIT.GET_LIST,
  },
  getStore: (store) => store.crmAudit,
});

export const actions = {
  ...listActions,
};

export default createReducer(INITIAL_STATE, (builder) => {
  extendListBuilder(builder, actions);
});
